import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";

export default function ServicesList() {
  return (
    <>
    <section className="servicepage-list">
        <div className="container">
            <div className="row align-items-center justify-content-end"> 

                <div className="col-lg-5 col-md-5">
                    <div className="servicelist-box wow animate__animated animate__slideInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
                        <span className="sub-tittle">Service 1</span>
                        <h3 className="heading">Modular Work</h3>
                        <p>We craft modern, sleek modular solutions for kitchens, wardrobes, and living spaces. Designed for function, style, and durability, our setups integrate seamlessly with your interiors, enhancing organization, productivity, and elegance.</p>
                        <Link to={"/modular-work"} className="default-btn colored-btn">Know More <Icons name="Longarrow_right"/></Link>
                    </div>
                </div>

                <div className="col-lg-5 col-md-5">
                    <img src="/image/service-list1.webp" loading="lazy" className="img-responsive" alt="service"/>
                </div>
            </div>

        </div>
    </section>


    <section className="servicepage-list">
        <div className="container">
            <div className="row align-items-center"> 

                <div className="col-lg-5 col-md-5">
                    <div className="servicelist-box wow animate__animated animate__slideInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
                        <span className="sub-tittle">Service 2</span>
                        <h4 className="heading">MillWork</h4>
                        <p>Our custom millwork adds character and sophistication to any space. From intricate wood detailing to functional installations, each piece is crafted with precision and premium materials, delivering timeless elegance and enduring quality.</p>
                        <Link to={"/millwork"} className="default-btn colored-btn">Know More <Icons name="Longarrow_right"/></Link>
                    </div>
                </div>

                <div className="col-lg-7 col-md-7">
                    <img src="/image/service-list2.webp" loading="lazy" className="img-responsive service-imggap" alt="service"/>
                </div>
            </div>

        </div>
    </section>


    <section className="servicepage-list">
        <div className="container">
            <div className="row align-items-center justify-content-center"> 

                <div className="col-lg-5 col-md-5">
                    <div className="servicelist-box wow animate__animated animate__slideInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
                        <span className="sub-tittle">Service 3</span>
                        <h4 className="heading">Bespoke Furniture</h4>
                        <p>Every space deserves unique, handcrafted furniture. We design and manufacture bespoke pieces tailored to your taste and lifestyle, combining comfort, aesthetics, and functionality for interiors that are personalized, luxurious, and iconic.</p>
                        <Link to={"/bespoke-furniture"} className="default-btn colored-btn">Know More <Icons name="Longarrow_right"/></Link>
                    </div>
                </div>

                <div className="col-lg-5 col-md-5">
                    <img src="/image/service-list3.webp" loading="lazy" className="img-responsive" alt="service"/>
                </div>
            </div>

        </div>
    </section>


    <section className="servicepage-list">
        <div className="container">
            <div className="row align-items-center"> 

                <div className="col-lg-5 col-md-5">
                    <div className="servicelist-box wow animate__animated animate__slideInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
                        <span className="sub-tittle">Service 4</span>
                        <h4 className="heading">Turnkey Solutions</h4>
                        <p>From concept to completion, we manage every detail of your project. Our turnkey solutions ensure seamless execution, luxury finishes, and timely delivery, transforming your vision into fully realized, stunning interiors.</p>
                        <Link to={"/turnkey-solution"} className="default-btn colored-btn">Know More <Icons name="Longarrow_right"/></Link>
                    </div>
                </div>

                <div className="col-lg-5 col-md-5">
                    <img src="/image/service-list4.webp" loading="lazy" className="img-responsive" alt="service"/>
                </div>
            </div>

        </div>
    </section>
    </>
  )
}
